import React from 'react';

// Ícone Oficial do Octopus - Usar imagem PNG
export const OctopusIcon = ({ className, size = 24, ...props }) => (
  <img 
    src="/assets/octopus-icon.png" 
    alt="Octopus"
    className={className}
    style={{ 
      width: size, 
      height: size, 
      objectFit: 'contain',
      ...props.style 
    }}
    {...props}
  />
);

// Versão SVG simplificada para fallback ou uso em contextos específicos
export const OctopusIconSvg = ({ className, ...props }) => (
  <svg 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Cabeça do polvo */}
    <ellipse cx="12" cy="8" rx="6" ry="5" />
    {/* Olhos */}
    <circle cx="10" cy="7" r="1" fill="currentColor" />
    <circle cx="14" cy="7" r="1" fill="currentColor" />
    {/* Tentáculos */}
    <path d="M6 12 C4 14 3 17 4 20" />
    <path d="M8 13 C7 15 6 18 7 21" />
    <path d="M10 13 C10 16 9 19 10 22" />
    <path d="M14 13 C14 16 15 19 14 22" />
    <path d="M16 13 C17 15 18 18 17 21" />
    <path d="M18 12 C20 14 21 17 20 20" />
  </svg>
);

// Ícone de Draga (Embarcação com roda de pás e tubo de sucção)
// Baseado no estilo line-art do Octopus
export const DredgeIcon = ({ className, ...props }) => (
  <svg 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="1.5" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Casco da embarcação */}
    <path d="M2 16 L4 18 L20 18 L22 16 L2 16" />
    {/* Proa elevada */}
    <path d="M2 16 L2 13 L5 13" />
    {/* Cabine de comando */}
    <rect x="4" y="10" width="4" height="6" />
    {/* Janelas da cabine */}
    <path d="M5 11 L7 11" />
    <path d="M5 12.5 L7 12.5" />
    {/* Mastro/antena */}
    <path d="M6 10 L6 6" />
    <path d="M5 7 L7 7" />
    {/* Roda de pás (caracol) - elemento central da draga */}
    <circle cx="13" cy="12" r="4" />
    {/* Pás internas da roda */}
    <path d="M13 8 L13 16" />
    <path d="M9 12 L17 12" />
    <path d="M10.2 9.2 L15.8 14.8" />
    <path d="M15.8 9.2 L10.2 14.8" />
    {/* Eixo central */}
    <circle cx="13" cy="12" r="1" />
    {/* Chaminé/exaustor */}
    <path d="M18 10 L18 7 L19 7 L19 10" />
    {/* Tubo de descarga (saindo pela lateral) */}
    <path d="M20 14 L22 15 L22 17" />
    <path d="M22 17 L23 18" />
    {/* Ondas */}
    <path d="M1 20 C3 19 5 21 7 20 C9 19 11 21 13 20 C15 19 17 21 19 20 C21 19 23 21 23 20" />
  </svg>
);

// Ícone de Pá Carregadeira (Wheel Loader)
export const WheelLoaderIcon = ({ className, ...props }) => (
  <svg 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Cabine */}
    <rect x="10" y="6" width="6" height="6" rx="1" />
    {/* Corpo/chassi */}
    <path d="M8 12 L18 12 L18 16 L8 16 Z" />
    {/* Braço da caçamba */}
    <path d="M10 10 L4 6 L2 8 L6 12" />
    {/* Caçamba */}
    <path d="M2 8 L1 5 L5 4 L4 6" />
    {/* Rodas traseiras (grandes) */}
    <circle cx="15" cy="18" r="3" />
    {/* Rodas dianteiras */}
    <circle cx="7" cy="18" r="2.5" />
    {/* Articulação central */}
    <path d="M10 14 L10 16" />
  </svg>
);

// Ícone de Motor Estacionário / Gerador Industrial
// Baseado no estilo line-art do Octopus - motor com alternador/gerador
export const EngineIcon = ({ className, ...props }) => (
  <svg 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="1.5" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Base/skid do gerador */}
    <path d="M2 20 L22 20" />
    <path d="M3 20 L3 18" />
    <path d="M21 20 L21 18" />
    {/* Corpo do motor (lado esquerdo) */}
    <rect x="3" y="10" width="8" height="8" rx="1" />
    {/* Cabeçote do motor */}
    <path d="M4 10 L4 8 L10 8 L10 10" />
    {/* Tampa de válvulas */}
    <path d="M5 8 L5 6 L9 6 L9 8" />
    {/* Escapamento com turbo */}
    <path d="M3 11 L1 11 L1 14" />
    <circle cx="1" cy="14" r="1" />
    {/* Aletas de resfriamento */}
    <path d="M4.5 12 L4.5 16" />
    <path d="M6 12 L6 16" />
    <path d="M7.5 12 L7.5 16" />
    <path d="M9 12 L9 16" />
    {/* Acoplamento motor-gerador */}
    <rect x="11" y="12" width="2" height="4" />
    {/* Corpo do alternador/gerador (lado direito) */}
    <ellipse cx="17" cy="14" rx="4" ry="4" />
    {/* Enrolamentos do gerador */}
    <ellipse cx="17" cy="14" rx="2.5" ry="2.5" />
    {/* Eixo do gerador */}
    <circle cx="17" cy="14" r="1" />
    {/* Caixa de conexões elétricas */}
    <rect x="19" y="10" width="3" height="3" />
    <path d="M22 11 L23 11" />
    <path d="M22 12 L23 12" />
    {/* Painel de controle (opcional) */}
    <rect x="14" y="6" width="5" height="3" />
    <circle cx="15.5" cy="7.5" r="0.5" fill="currentColor" />
    <circle cx="17.5" cy="7.5" r="0.5" fill="currentColor" />
  </svg>
);

// Ícone de Embarcação/Rebocador
export const TugboatIcon = ({ className, ...props }) => (
  <svg 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Casco */}
    <path d="M3 15 L5 19 L19 19 L21 15 L3 15" />
    {/* Superestrutura */}
    <rect x="7" y="10" width="10" height="5" />
    {/* Ponte de comando */}
    <rect x="9" y="6" width="6" height="4" />
    {/* Chaminé */}
    <rect x="15" y="4" width="2" height="6" />
    {/* Fumaça */}
    <path d="M16 4 C16 2 18 2 18 4" />
    {/* Ondas */}
    <path d="M2 21 C4 20 6 22 8 21 C10 20 12 22 14 21 C16 20 18 22 20 21 C22 20 22 21 22 21" />
  </svg>
);

export default {
  OctopusIcon,
  DredgeIcon,
  WheelLoaderIcon,
  EngineIcon,
  TugboatIcon
};
